import type { ReactElement } from 'react'
import React from 'react'

import { caption } from '@ui-kit/core/typography'

import RadioCard from './RadioCard/index.web'
import * as styles from './styles'
import { radioCardTestID } from './testID'
import type { RadioOptionValue, WebProps } from './types'

const RadioCardSet = (props: WebProps): ReactElement => {
  const layout = props.layout ?? 'compact'

  const onOptionClick = (newValue: RadioOptionValue) => {
    if (newValue === props.value) {
      return
    }

    if (typeof props.onValueChange === 'function') {
      props.onValueChange(newValue)
    }
  }

  const options = props.options.filter((option) => !option.hidden)
  const { hasTopTags, hasBottomTags, container, list } = styles.getRadioCardSetStyles(
    props.options,
    layout,
    props.variant
  )

  return (
    <div className={container()}>
      <div className={list()}>
        {options.map((option) => (
          <RadioCard
            {...option}
            hasBottomTags={hasBottomTags}
            hasTopTags={hasTopTags}
            onClick={onOptionClick}
            key={String(option.value)}
            layout={option.layout ?? layout}
            variant={props.variant}
            isSelected={option.value === props.value}
            isUntouched={props.value === undefined}
            disabled={option.disabled || props.disabled || false}
            testID={radioCardTestID(props.testID, option.value)}
          />
        ))}
      </div>
      {props.errorMessage && <p className={caption({ color: 'error' })}>{props.errorMessage}</p>}
    </div>
  )
}

export default RadioCardSet
